import "@cloudscape-design/global-styles/index.css";

export const LmsRedirect = () => {
 return (
   <div className="cq-content">
     <p>
       Go to your LMS to authenticate again.
     </p>
   </div>
 );
};